import Home from "../Components/Home";


const Show = () =>{
    return(
        <div>
            <Home/>
        </div>
    )
}

export default Show